import { usePlpRefinements } from "~/hec/context/plp-refinement-context";
import { useCioBrowseProducts } from "~/routes/resources/cio-browse";

export const useFetchCioProductCategory = (
  categoryId: string,
  resultCount: number,
  shouldQuery: boolean,
) => {
  // SFCC-11958: inherit the surrounding listing grid's refinement so a carousel
  // rendered as a grid cell can't surface products the grid filtered out.
  // Sourced from a context, not the URL: this block is author-placed and can
  // legitimately sit on a PDP, whose variation params (`color`, `count`) are
  // also configured CIO facets. Outside a listing grid this is "".
  const refinements = usePlpRefinements();

  const { products, categoryName, isLoading, hasLoaded } = useCioBrowseProducts(
    {
      categoryId: shouldQuery ? categoryId : undefined,
      resultsPerPage: resultCount,
      refinements,
    },
  );

  // SFCC-11820: `hasLoaded` lets the carousel tell a settled-empty browse (valid
  // category with 0 results, or a CIO failure the resource loader swallows into
  // `products: []`) apart from an in-flight fetch — so it can collapse instead of
  // rendering skeleton tiles forever. That collapse is also the intended
  // degradation for SFCC-11958: a refinement the carousel's own category can't
  // satisfy returns zero products, and it removes itself.
  return { products, categoryName, isLoading, hasLoaded };
};
